module.exports = __webpack_public_path__ + "media/images/gift-thanks-modal-bg-steak@3x-eab79216cca0cc642c80dec8897e8a69.png";